// extracted by mini-css-extract-plugin
module.exports = {"container":"EmailVerification_container__sGXV8","content":"EmailVerification_content__ZTWaP","info":"EmailVerification_info__aSajW"};